<template>
  <div
    class="ht300-container"
    v-loading="loading.value"
    :element-loading-text="loading.text"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="ht300-container-top-area">
      <MCard
        class="content left"
        title="离子迁移谱图"
        theme="light"
        title-align="left"
        :icon="icon1"
        ref="content"
        v-loading="pageLoading"
        element-loading-background="rgba(0, 0, 0, 0.5)"
        :element-loading-text="loadingText"
      >
        <div
          class="check-res"
          style="background-image: url('/static/image/ht300/bg.png')"
          @click.stop="handleSubstanceFlow(checkResult)"
        >
          检测结果: {{ checkResult }}
        </div>
        <chartView :chartValOp="positiveElectrode" />
        <chartView :chartValOp="negativeElectrode" style="margin-top: -70px" />
      </MCard>

      <MCard
        class="content"
        title="核模块数据"
        theme="light"
        title-align="left"
        :icon="icon2"
        ref="content"
      >
        <div class="nucleus-mods">
          <div class="nucleus-mods-item" v-for="(item, index) in nucleusModsData" :key="index">
            <stateCard :item="item" />
          </div>
        </div>
      </MCard>
    </div>

    <div class="ht300-container-bottom-area">
      <MCard
        class="content"
        title="传感器数据"
        theme="light"
        title-align="left"
        :icon="icon3"
        ref="content"
      >
        <div
          v-if="isEmpty(sensorModsData)"
          style="text-align: center; height: 60px; line-height: 60px"
        >
          暂无传感器数据
        </div>

        <div class="sensor-mods" v-else>
          <div class="sensor-mods-item" v-for="(item, index) in sensorModsData" :key="index">
            <stateCard :item="item" />
          </div>
        </div>
      </MCard>
    </div>
  </div>
</template>

<script>
import MCard from '@/components/mCard/index.vue';
import chartView from './components/chart.vue';
import stateCard from './components/stateCard.vue';
import casMixin from '@/mixins/deviceCasMixin';

import singleDeviceMixin from '@/mixins/singleDeviceMixin';
import { isEmpty } from '@/utils/is';

export default {
  name: 'HT300',
  mixins: [singleDeviceMixin, casMixin],
  data() {
    return {
      showDom: false,
      checkResult: '',
      title: '测试',
      icon1: {
        type: 'image',
        config: {
          src: '/static/image/ht300/icon1.png'
        }
      },

      icon2: {
        type: 'image',
        config: {
          src: '/static/image/ht300/icon2.png'
        }
      },
      icon3: {
        type: 'image',
        config: {
          src: '/static/image/ht300/icon3.png'
        }
      },

      positiveElectrode: {
        // color: ['#833BBB', '#3368F2'],
        yAxis: [
          {
            name: '正极 P',
            nameTextStyle: {
              color: '#fff'
            },
            type: 'value',
            axisLine: {
              lineStyle: {
                type: 'dashed'
              }
            },
            axisLabel: {
              show: false
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#264765',
                type: 'dashed',
                width: 1
              }
            }
          },
          {
            name: '',
            nameLocation: 'start',
            nameTextStyle: {
              color: '#fff'
            },
            axisLine: {
              lineStyle: {
                type: 'dashed'
              }
            },
            alignTicks: true,
            type: 'value',
            inverse: true
          }
        ],

        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisLabel: {
            show: false
          },
          axisLine: {
            lineStyle: {
              type: 'dashed'
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#264765',
              type: 'dashed',
              width: 1
            }
          }
        },

        series: [
          {
            type: 'line',
            smooth: false,
            symbol: 'none',
            lineStyle: {
              color: '#5470C6',
              width: 2
            },
            data: []
          }
        ]
      },
      negativeElectrode: {
        yAxis: [
          {
            name: '负极 N',
            nameTextStyle: {
              color: '#fff'
            },
            type: 'value',
            axisLine: {
              lineStyle: {
                type: 'dashed'
              }
            },
            axisLabel: {
              show: false
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#264765',
                type: 'dashed',
                width: 1
              }
            }
          }
        ],

        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisLabel: {
            show: false
          },

          axisLine: {
            lineStyle: {
              type: 'dashed'
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#264765',
              type: 'dashed',
              width: 1
            }
          }
        },

        series: [
          {
            type: 'line',
            smooth: false,
            symbol: 'none',
            lineStyle: {
              color: '#5470C6',
              width: 2
            },
            data: []
          }
        ]
      },
      //   核模块数据
      nucleusModsData: [
        {
          name: '剂量率',
          key: 'dose',
          value: 0,
          state: 0,
          unitName: 'μSv/h',
          showImg: true
        },
        {
          name: '故障状态',
          key: 'faultStatus',
          value: 0,
          unitName: '-',
          showImg: true,
          state: 0
        }
        // {
        //   name: '累计剂量uSv',
        //   value: 20.15,
        //   state: 1,
        //   unit: 'usv',
        //   time: '2025年1月-2025年10月',
        //   showImg: true
        // }
      ],

      //  传感器数据
      sensorModsData: []
    };
  },

  methods: {
    async initPage() {
      if (this.isHisDetail) {
        await this.getHistoryDetailData(this.eventId);
        this.hideLoading();
      }
    },
    updateData(res) {
      let {
        mods: { ht300Mod }
      } = res;

      // 监测结果
      this.checkResult = ht300Mod.j218RunStatDto?.subsReportDto?.name || '-';

      //  剂量率
      if (!isEmpty(ht300Mod.ht300RadiationDataDto)) {
        this.nucleusModsData[0].value = ht300Mod.ht300RadiationDataDto.radValue;
        this.nucleusModsData[0].state = ht300Mod.ht300RadiationDataDto.radAlarmState;
        this.nucleusModsData[1].value =
          ht300Mod.ht300RadiationDataDto.radRunstate == 0 ? '正常' : '故障';
        this.nucleusModsData[1].state = ht300Mod.ht300RadiationDataDto.radRunstate;

        //  故障状态
      }
      //   正极
      this.positiveElectrode.series[0].data = ht300Mod.specDataDtoPos?.data || [];
      //   负级
      this.negativeElectrode.series[0].data = ht300Mod.specDataDtoNeg?.data || [];

      // 传感器

      if (ht300Mod.sensorDataList) {
        ht300Mod.sensorDataList.forEach(item => {
          item.state = item.alarmState;
          item.showRightLine = true;
        });
        this.sensorModsData = ht300Mod.sensorDataList.sort((a, b) => {
          return b.state - a.state;
        });

        this.sensorModsData[this.sensorModsData.length - 1].showRightLine = false;
      }

      this.hideLoading();
    },
    isEmpty,

    hideLoading() {
      if (!this.loading) return;
      const timer = setTimeout(() => {
        this.loading.value = false;
        clearTimeout(timer);
      }, 500);
    }
  },
  components: {
    MCard,
    chartView,
    stateCard
  },
  created() {
    this.hideLoading();
    // this.initPage();
  }
};
</script>

<style scoped lang="scss">
.ht300-container {
  --scale-num: 1;
  --nucleus-mods-h: 399px;
  padding: 10px;
  box-sizing: border-box;

  @media screen and (max-width: 1200px) {
    --mcard-header-fs: 10px;
    --nucleus-mods-h: 280px;

    --scale-num: 0.7;
  }
  &-top-area {
    display: flex;
    align-items: center;
    gap: 20px;
    justify-content: space-between;
    .left {
      ::v-deep .m-card_content {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }
    }

    .content {
      .check-res {
        transform: scale(var(--scale-num));

        cursor: pointer;
        font-size: 20px;
        min-width: 220px;
        height: 52px;
        line-height: 52px;
        text-align: center;
        background-repeat: no-repeat;
        background-size: cover;
        color: #fff;
        font-weight: bold;
        font-size: 20px;
        margin-top: 20px;
      }
    }
    .nucleus-mods {
      transform: scale(var(--scale-num));
      height: var(--nucleus-mods-h);
      box-sizing: border-box;
      padding: 23px 0;
      display: flex;
      justify-content: space-around;
    }
  }

  &-bottom-area {
    margin-top: 20px;
    .sensor-mods {
      box-sizing: border-box;
      padding: 20px;
      display: flex;
      justify-content: flex-start;
      &-item {
        transform: scale(var(--scale-num));
      }
    }
  }
}
</style>
